import { AssetRepository } from '@/lib/assets/types'
import { MeilisearchAssetRepository } from '@/lib/assets/repositories/meilisearch-asset-repository'
import { LegacyApiAssetRepository } from '@/lib/assets/repositories/legacy-api-asset-repository'

/**
 * Instantiates the repository for listing assets.
 */
export const forListing = (): AssetRepository => {
  return new MeilisearchAssetRepository()
  // return new LegacyApiAssetRepository()
}

/**
 * Instantiates the repository for details of a single asset.
 */
export const forDetails = (): AssetRepository => {
  return new LegacyApiAssetRepository()
}

/**
 * Instantiates the repository for searching assets.
 */
export const forSearch = (): AssetRepository => {
  return new MeilisearchAssetRepository()
}
